import { render, staticRenderFns } from "./ListItineraries.vue?vue&type=template&id=2a1f03a4"
import script from "./ListItineraries.vue?vue&type=script&lang=js"
export * from "./ListItineraries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports